import React from 'react';
function Map({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 7.2V20l5.727-3.2 6.546 3.2L21 16.8V4l-5.727 3.2L8.727 4 3 7.2zM9 4v13M15 7v13"
      />
    </svg>
  );
}

export default Map;
